import * as React from "react";
import { useNavigate } from "react-router";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import styles from "src/components/UI/LeftCard/assets/scss/Menu.module.scss";
import paths from "src/config/search.json";
import { _GetTitle, _GetType } from "src/components/UI/Shared/handler";
import {
  FreeIcon,
  PremiumIcon,
  MixedIcon,
} from "src/components/UI/LeftCard/icons";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";

interface ControlledOpenSelectProps {}

const ControlledOpenSelect = ({}: ControlledOpenSelectProps) => {
  const dispatch = useDispatch();
  const searchString = useSelector((state: any) => state.app.searchString);
  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleChange = (event: SelectChangeEvent) => {
    dispatch(
      appActions.setSearchString({
        ...searchString,
        menu1: event.target.value,
      })
    );
  };
  const keys = Object.keys(paths.services);
  const currentkey = keys[0];

  const handleGoToSearchString = (choosen: string) => {
    if (choosen === "upload-data") {
      navigate(`${currentkey}/${paths.services.Import_Your_Data[0].url}`);
    } else if (choosen === "local-storage") {
      navigate(`${currentkey}/${paths.services.Import_Your_Data[2].url}`);
    } else if (choosen === "layer-from-url") {
      navigate(`${currentkey}/${paths.services.Import_Your_Data[1].url}`);
    }
  };
  React.useEffect(() => {
    handleGoToSearchString(searchString.menu1);
  }, [searchString]);
  const Icon = (category: number, item: number) => {
    const type = _GetType(category, item);
    if (type === "free") return <FreeIcon />;
    else if (type === "premium") return <PremiumIcon />;
    return <MixedIcon />;
  };
  return (
    <div>
      <FormControl sx={{ m: 1, minWidth: 120, margin: "1.5rem 0 0.75rem 0" }}>
        <InputLabel
          id="demo-controlled-open-select-label"
          className={styles.label}
        >
          Import Your Data
        </InputLabel>
        <Select
          className={styles.select}
          labelId="demo-controlled-open-select-label"
          id="demo-controlled-open-select"
          open={open}
          value={searchString.menu1}
          onChange={handleChange}
          onClose={handleClose}
          onOpen={handleOpen}
          label="selectValue"
        >
          <MenuItem className={styles.menuItem} value={"upload-data"}>
            {_GetTitle(0, 0)}
            {Icon(0, 0)}
          </MenuItem>
          <MenuItem className={styles.menuItem} value={"layer-from-url"}>
            {_GetTitle(0, 1)}
            {Icon(0, 1)}
          </MenuItem>
          <MenuItem className={styles.menuItem} value={"local-storage"}>
            {_GetTitle(0, 2)}
            {Icon(0, 2)}
          </MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default ControlledOpenSelect;
